import { c as _c } from "react/compiler-runtime";
import { ApiClient } from '@/services/api-client';
import socketClient from '@/services/socket-client';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
const QUERY_KEY = ['lead.waitingAiResponseCount'];
export function useWaitingAiResponseCount() {
  const $ = _c(4);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: QUERY_KEY,
      queryFn: _temp,
      staleTime: 60000,
      refetchOnWindowFocus: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const q = useQuery(t0);
  let t1;
  let t2;
  if ($[1] !== queryClient) {
    t1 = () => {
      let isMounted = true;
      const cleanupRef = {};
      const setup = async () => {
        const socket = await socketClient.getSocket();
        if (!socket || !isMounted) {
          return;
        }
        const onSkipped = () => {
          queryClient.invalidateQueries({
            queryKey: QUERY_KEY
          });
        };
        socket.on("ai_response_skipped", onSkipped);
        cleanupRef.socket = socket;
        cleanupRef.onSkipped = onSkipped;
      };
      setup();
      return () => {
        isMounted = false;
        if (cleanupRef.socket) {
          cleanupRef.socket.off("ai_response_skipped", cleanupRef.onSkipped);
        }
      };
    };
    t2 = [queryClient];
    $[1] = queryClient;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return q.data ?? 0;
}
async function _temp() {
  const res = await ApiClient.lead.getSearchIndex({
    classification: "waiting_ai_response"
  });
  return res.data?.Previews?.length ?? 0;
}